



































































































































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { SweetAlertOptions } from 'sweetalert2';
import { Saque, Api, Auth } from '@/plugins/api';
import { FilePond } from 'filepond';
import ComissoesTable from '@/views/app/Comissoes/components/ComissoesTable.vue';
import CardIndicador from '@/views/app/Indicadores/components/CardIndicador.vue';
import ComprovantesGrid from '@/views/app/Indicadores/components/ComprovantesGrid.vue';
import AnexosGrid from './components/AnexosGrid.vue';
import ObservacoesList from './components/ObservacoesList.vue';

@Component({
  components: {
    CardIndicador,
    ComprovantesGrid,
    AnexosGrid,
    ObservacoesList,
  },
})
export default class InfoSaque extends Vue {
  @Ref() readonly comissoesTable!: ComissoesTable;
  @Ref() readonly filepond!: FilePond;
  public selectedTab = 0;
  public progressSituacao = false;
  public notificacao = true;
  public optionsNotificacao = [
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' },
  ];

  public loadingSaque = true;
  public saqueId!: number;
  public indicadorId = 0;
  public saque = {
    comprovantes: [] as IComprovante[],
    anexos: [] as IAnexo[],
    observacoes: [] as IObservacoes[],
  } as ISaque;

  public popoverPago = false;
  public popoverRejeitado = false;
  public filePondComprovante = {};

  public observacao = '';

  created(): void {
    this.loadingSaque = true;
    this.saqueId = parseInt(this.$route.params.id, 10);
    this.updateInfo();

    this.filePondComprovante = {
      url: Api.baseUrl,
      process: {
        url: `/saques/${this.saqueId}/comprovantes`,
        headers: {
          Authorization: Auth.instance.token,
        },
      },
    };
  }

  updateInfo(): void {
    this.loadingSaque = true;

    Saque.getByID(this.saqueId)
      .then((response: GetSaqueResponse) => {
        this.loadingSaque = false;
        this.saque = response.data;
        this.indicadorId = this.saque.id_indicador;
      })
      .catch((err) => {
        this.$router.replace('/saques');
        this.$swal({
          icon: 'error',
          title: err.response.data,
        });
      });
  }

  openPago(): void {
    this.popoverRejeitado = false;
    // Só abre se não tiver comprovantes
    // se tiver já marca como pago
    if (this.saque.comprovantes.length === 0) {
      this.popoverPago = !this.popoverPago;
    } else {
      this.popoverPago = false;
      this.marcarSituacao('pago');
    }
  }

  openRejeitado(): void {
    this.popoverPago = false;
    this.popoverRejeitado = !this.popoverRejeitado;
  }

  marcarSituacao(situacao: string): void {
    this.progressSituacao = true;
    this.popoverPago = false;
    this.popoverRejeitado = false;
    const params: PatchSaqueRequest = {
      situacao: situacao,
      notificacao: this.notificacao,
      observacao: this.observacao,
    };
    Saque.patch(this.saqueId, params)
      .then((response) => {
        this.comissoesTable?.refresh();
        this.updateInfo();
        this.toastSuccessError(response.success, response.email ?? false);
        this.observacao = '';
      })
      .catch(() => {
        this.toastSuccessError(false);
      })
      .finally(() => {
        this.progressSituacao = false;
      });
  }

  toastSuccessError(success: boolean, email?: boolean): void {
    let options: SweetAlertOptions;
    if (success) {
      const text = email ?? false ? 'Email enviado para indicador' : undefined;
      options = {
        icon: 'success',
        title: 'Salvo com sucesso!',
        text: text,
      };
    } else {
      options = {
        icon: 'error',
        title: 'Falha ao mudar situação!',
      };
    }
    this.$swal(options);
  }

  uploadedFiles(): void {
    this.updateInfo();
  }
}
